import { Navigate, useLocation } from "react-router-dom";
import { routesPermission } from "../utils/constant";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("token");
  const role = localStorage.getItem('role');
  const location = useLocation();

  if (!isLoggedIn || !role) {
    return <Navigate to="/login" replace />;
  }

  const allowedRoutes = routesPermission[role];
  const isAllowed = allowedRoutes?.some((route) => location.pathname.startsWith(route));

  if (isAllowed) {
    return children;
  }
  const firstRoute = routesPermission[role]?.[0];
  if (firstRoute) {
    return <Navigate to={firstRoute} replace />;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
